<script module lang="ts">
  import type { Snippet } from 'svelte';

  export interface Props {
    removeMarginTop?: boolean;
    layerAbs?: boolean;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { LayerHandler } from '../../handlers/LayerHandler';

  const { removeMarginTop, layerAbs, children, ...toNext }: Props = $props();

  // -
  const Layer = new LayerHandler();
  const MyLayer = Layer.upContentLayer();
</script>

<div {...toNext} class="contentLayer contentLayer{MyLayer} {removeMarginTop ? 'noMarginTop' : ''} {layerAbs ? 'contentLayerChildAbs' : ''}">
  {@render children?.()}
</div>
